import Session from 'apis/sdk'
import Accounts from 'apis/sdk/accounts'
import cookie from 'react-cookies';
import {
 SITE_SETTINGS,
 THEME_ACTIONS,
} from '../constants';

const INIT_STATE = {
 company:false,
 dashhboard:false,
 network:false,
 site:false,
 user:false,
 theme:{isLoaded:false,isApplied:false}
};
export default (state = INIT_STATE, action) => {
  var stateRefresh = (action.payload) ? action.payload : action;
  switch (action.type) {
    
    case SITE_SETTINGS:
      
      return {
        ...state,
        ...stateRefresh.siteSettings
      }
    break;

    case THEME_ACTIONS:
      var _theme = state.theme;
          _theme = {..._theme,...action.payload}
      return {
        ...state,
        theme:_theme
      }
    break;


    default:
      return { ...state };
  }
};
